import React from "react";
import pop from "../../media/images/genres/pop.jpg";
import pop50 from "../../media/images/genres/pop50.jpg";
import eopop from "../../media/images/genres/eopop.jpg";
import pop2021 from "../../media/images/genres/edm2021.jpg";
import edmhp from "../../media/images/genres/edmhp.jpg";
import edmncs from "../../media/images/genres/edmncs.jpg";
import boedm from "../../media/images/genres/boedm.jpg";
import edmh from "../../media/images/genres/edmh.jpg";
import edmh2020 from "../../media/images/genres/edmh2020.png";
import edm2010 from "../../media/images/genres/edm2010.jpg";
import edmdm from "../../media/images/genres/edmdm.jpg";
import edmge from "../../media/images/genres/edmge.jpg";
import jazz from "../../media/images/genres/jazz.jpg";
import jazzl from "../../media/images/genres/jazzl.jpg";
import CardPrimary from "../../components/card/CardPrimary";

const Genres = () => {
  return (
    <div className="genres">
      <div className="section">
        <h3>Pop Music</h3>
        <div className="cards">
          <CardPrimary img={pop} alt="Trending pop hits" text="Trending pop hits" desc="Playlist" />
          <CardPrimary img={pop50} alt="Top 50 pop songs" text="Top 50 pop songs" desc="Playlist" />
          <CardPrimary
            img={eopop}
            alt="Evolution of pop music 80s - now"
            text="Evolution of pop music 80s - now"
            desc="Playlist"
          />
        </div>
      </div>

      <div className="section">
        <h3>Electronic Music</h3>
        <div className="cards">
          <CardPrimary img={pop2021} alt="Trending latest EDM songs" text="Trending latest EDM songs" desc="Playlist" />
          <CardPrimary img={edmhp} alt="EDM house music" text="EDM house music" desc="Playlist" />
          <CardPrimary img={edmncs} alt="Top NCS songs" text="Top NCS songs" desc="Playlist" />
          <CardPrimary img={boedm} alt="Best of EDM" text="Best of EDM" desc="Playlist" />
          <CardPrimary img={edmh} alt="EDM hits of all time" text="EDM hits of all time" desc="Playlist" />
          <CardPrimary img={edmh2020} alt="EDM hits 2020" text="EDM hits 2020" desc="Playlist" />
          <CardPrimary img={edm2010} alt="Top 20 EDM of 2010" text="Top 20 EDM of 2010" desc="Playlist" />
          <CardPrimary img={edmdm} alt="EDM dance music" text="EDM dance music" desc="Playlist" />
          <CardPrimary img={edmge} alt="EDM of this generation" text="EDM of this generation" desc="Playlist" />
        </div>
      </div>

      <div className="section">
        <h3>Jazz Music</h3>
        <div className="cards">
          <CardPrimary img={jazz} alt="Trending jazz hits" text="Trending jazz hits" desc="Playlist" />
          <CardPrimary img={jazzl} alt="Jazz live" text="Jazz live" desc="Playlist" />
        </div>
      </div>
    </div>
  );
};

export default Genres;
